import { getCountriesBy } from 'legacy/lut/components/shared/LocationTreeFetcher'

import { IForm } from 'core-components/classes/models/IForm'
import { ICheckedValue } from 'core-components/library/list/types'
import {
  ICountryWithCluster,
  IPartnerTerritory,
} from 'onboarding/classes/models/partnerTerritoryModels'

/**
 * @param items - Mutates elements of items!
 * @param partnerTerritory
 */
export const applyTotalSelectedCounts = (items: IForm[], partnerTerritory: IPartnerTerritory) => {
  let countries: ICountryWithCluster[] = []
  for (const item of items) {
    switch (item.Type) {
      case 'Market':
      case 'Cluster':
      case 'Region':
      case 'HpOrg':
      case 'ClusterCountry':
        countries = getCountriesBy(item.Type, item.Title, partnerTerritory)
        item.childrenCount = countries.length
        item.uncheckedCount = countries.length
        break
      case 'Country':
      case 'CountryWithParentAsCluster':
        item.childrenCount = 1
        item.uncheckedCount = 1
        break
    }
  }
}

/**
 * @param items - Mutates elements of items!
 * @param countriesNames
 */
export const applySubtractSelected = (items: IForm[], countriesNames: string[]) => {
  for (const countryName of countriesNames) {
    const selectedItems = items.filter(
      (i) => (i.name && i.name.toLowerCase()) === countryName.toLowerCase()
    )
    for (const item of selectedItems) {
      if (item) {
        item.uncheckedCount = item.uncheckedCount - 1
        applySubtractParentRecursive(items, item)
      }
    }
  }
}

/**
 * @param items - Mutates elements of items!
 * @param item
 */
const applySubtractParentRecursive = (items: IForm[], item: IForm) => {
  const parent = items.find((el) => el.Id === item.Parent)
  if (parent) {
    parent.uncheckedCount = parent.uncheckedCount - 1
    applySubtractParentRecursive(items, parent)
  }
}

export const getSelectedCheckboxesValues = (items: IForm[]) => {
  const checked: ICheckedValue[] = []
  items.forEach((item) => {
    if (item.uncheckedCount === 0 && item.childrenCount > 0) {
      checked.push({ key: item.Id, value: 'full' })
    } else if (item.uncheckedCount < item.childrenCount) {
      checked.push({ key: item.Id, value: 'indeterminate' })
    }
  })

  return checked
}

type TParams = {
  locationItems: IForm[]
  countriesNames: string[]
  partnerTerritory: IPartnerTerritory
}

export const composeSelectedCheckboxesValues = ({
  locationItems,
  countriesNames,
  partnerTerritory,
}: TParams) => {
  const local = locationItems.slice()
  applyTotalSelectedCounts(local, partnerTerritory)
  applySubtractSelected(local, countriesNames)

  return getSelectedCheckboxesValues(local)
}

export const getSelectedCluster = (
  checkedValues: ICheckedValue[],
  country: ICountryWithCluster
) => {
  return (
    checkedValues.find(
      (checkedValue) =>
        checkedValue.value === 'full' &&
        country.clusters?.find((cluster: string) => `Cluster-${cluster}` === checkedValue.key)
    ) ?? null
  )
}
